export let AlphaTransparencyBinTypeName: string = "AlphaTransparency";
export let BillboardBinTypeName: string = "Billboard";
export let ChunkLODBinTypeName: string = "ChunkLOD";
export let HUDBinTypeName: string = "HUD";
export let LinesBinTypeName: string = "Lines";
export let NewHUDBinTypeName: string = "NewHUD";
export let OpaqueBinTypeName: string = "Opaque";
export let OpaqueNoTextureBinTypeName: string = "OpaqueNoTexture";
export let OutlinesBinTypeName: string = "Outlines";
export let ParticlesBinTypeName: string = "Particles";
export let PoiBinTypeName: string = "Poi";
export let PointCloudsBinTypeName: string = "PointClouds";
export let PointsBinTypeName: string = "Points";
export let ShadowVolumesBinTypeName: string = "ShadowVolumes";
export let SkyBoxBinTypeName: string = "SkyBox";
export let SkyDomeBinTypeName: string = "SkyDome";
export let TextBinTypeName: string = "Text";
export let TransparentBinTypeName: string = "Transparent";
export let TransparentNoTextureBinTypeName: string = "TransparentNoTexture";
export let TransparentInternalBinTypeName: string = "TransparentInternal";
export let TransparentNoTextureInternalBinTypeName: string = "TransparentNoTextureInternal";